import './TerminologyOverlay.css';
export var trigger = '_1dd8zuz0-3-5-0';